export interface KpiOption {
    key: string;
    name: string;
    sortable: boolean;
}

export interface KpiHelpers {
    getKpiByKey: (key: string) => KpiOption | undefined;
    getKpiName: (key: string) => string;
}

/**
 * Builds lookup helpers over a config-provided KPI catalog. The catalog itself
 * is derived from `metrics[]` (group `kpi_metrics`, see `kpiCatalogAdapter`) and
 * is distributed via `CustomerConfigContext`; there is no static catalog anymore.
 */
export const createKpiHelpers = (catalog: readonly KpiOption[]): KpiHelpers => {
    const byKey = new Map(catalog.map((kpi) => [kpi.key, kpi]));
    return {
        getKpiByKey: (key: string) => byKey.get(key),
        getKpiName: (key: string) => byKey.get(key)?.name ?? key,
    };
};
